import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import srcArial from '../../../assets/custom/font/arial/arial.ttf';
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf';
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import PropinsiEn from "../../../utilities/PropinsiEn";
import imgCheckBox from "../../../assets/images/icons/checkbox_blank_outline_icon.png"
import imgCheckBoxIcon from "../../../assets/images/icons/checkbox_icon.png"
import { formatDateStringLocalDate } from "../../../utilities/Utils";
import Kemasan from "../../../utilities/Kemasan";
import TipeTemp from "../../../utilities/TipeTemp";

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial MT Black', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 40,
        paddingBottom: 48,
        paddingHorizontal: 32,
        boxSizing: "border-box"
    },
    page1: {
        paddingTop: 20,
        paddingBottom: 28,
        paddingHorizontal: 32,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingEn: {
        fontFamily: "Arial MT Black",
        fontSize: 10,
        textAlign: "center",
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableIsi: {
        display: 'table',
        width: 'auto',
    },
    tableRowPart: {
        width: '100%',
        flexDirection: 'row',
        backgroundColor: '#D3D3D3',
    },
    tableColPart: {
        width: '100%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol: {
        padding: 5,
        textAlign: 'right',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableColIsi: {
        padding: 3,
        textAlign: 'left',
    },
    text: {
        fontFamily: "Arial",
        fontSize: 10,
        textAlign: "left",
    },
    textIsi: {
        fontFamily: "Arial",
        fontSize: 9,
        textAlign: "left",
    },
    textBoldIsi: {
        fontFamily: "Arial MT Black",
        fontSize: 9,
        textAlign: "center",
    },
    textBold: {

        fontFamily: "Arial MT Black",
        fontSize: 10,
    },
    squareStyle: {
        width: '10px',
        height: '10px',
        border: 1,
        borderColor: '#000000',
    },
    checkicon: {
        width: 12,
        height: 12
    }
})

const DraftUK = ({ dataDisposisi, datappm, qrImage }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [upt, setUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmMutuArea, setPpmMutuArea] = useState(null)
    const [ppmMutuProd, setPpmMutuProd] = useState([])
    const [ppmKemasan, setPpmKemasan] = useState([])

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const jsonMutuPK = {
                nomorAju: datappm.nomorAju,
                noProses: dataDisposisi.noTugas
            };

            const jsonPelMuat = {
                jnsPelabuhan: "D",
                kodePelabuhan: datappm.pelabuhanMuat
            };

            const jsonPelBongkar = {
                jnsPelabuhan: "L",
                kodePelabuhan: datappm.pelabuhanBongkar
            };

            const results = await Promise.allSettled([
                transaksiService.getHcMutuById(jsonMutuPK),
                userService.getUptById(datappm.kdUpt),
                masterService.getNegaraById(datappm.negaraPartner),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelBongkar)),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                transaksiService.getPpmMutuById(datappm.nomorAju),
                transaksiService.listPpmMutuProdAll(datappm.nomorAju),
                transaksiService.listPpmMutuAreaAll(datappm.nomorAju)
            ])

            const [
                resHc,
                resUpt,
                resNeg,
                resPelMuat,
                resPelBongkar,
                resDetil,
                resKemasanAll,
                resKontainer,
                resMutu,
                resMutuProd,
                resMutuArea
            ] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            // Update state (batched oleh React)
            setDataHc(getData(resHc));
            setUpt(getData(resUpt, {}));
            setNegaraTujuan(getData(resNeg, {}))
            setPelMuat(getData(resPelMuat, {}));
            setPelBongkar(getData(resPelBongkar, {}));
            setPpmDetil(getData(resDetil));
            setPpmKemasan(getData(resKemasanAll));
            setPpmKontainer(getData(resKontainer));
            setPpmMutu(getData(resMutu, {}));
            setPpmMutuProd(getData(resMutuProd));
            setPpmMutuArea(getData(resMutuArea))

        } catch (error) {
            console.error("Gagal memuat data:", error);
        }

    }, [datappm, dataDisposisi, transaksiService, masterService, userService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap={false}>
                <View>
                    <Text style={styles.headingEn}>Model health certificate for the placing on the market of fishery products (FP)</Text>
                    <Text style={[styles.headingEn, { paddingBottom: 20 }]}>GBHC401 v1.1 Aug-23</Text>
                </View>
                <View style={styles.table}>
                    <View style={styles.tableRowPart}>
                        <View style={[styles.tableColPart, { borderBottom: 0, backgroundColor: "#000000" }]}>
                            <Text style={[styles.textBold, { color: "#ffffff" }]}>Part I. Details of dispatched consignment</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderTop: 0 }]}>
                    <View style={[styles.table, { width: '35%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.1 Consignor / exporter : </Text>
                                <Text style={styles.text}>Name : {dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                                <Text style={styles.text}>Address : </Text>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                                </View>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}>Tel : {dataHc !== null ? dataHc.telpPengirim : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '35%', borderTop: 0, borderRight: 0 }]}>
                        <View style={[styles.tableRow, { borderBottom: 1 }]}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.2 Certificate reference no.</Text>
                                <Text style={styles.text}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRowPart}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.2.a Not in use</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '35%', borderTop: 0 }]}>
                        <View style={[styles.tableRow, { borderBottom: 1 }]}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.3 Central competent authority</Text>
                                <Text style={styles.text}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.4 Local competent authority</Text>
                                <Text style={styles.text}>{upt !== null ? upt.nmInggris : '-'}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderTop: 0 }]}>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.5 Consignee / importer : </Text>
                                <Text style={styles.text}>Name : {dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                                <Text style={styles.text}>Address : </Text>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.alPenerima : ''}</Text>
                                </View>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}>Tel : {dataHc !== null ? dataHc.telpPenerima : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 1 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.6 Operator responsible for the consignment</Text>
                                <Text style={styles.text}>Name : </Text>
                                <Text style={styles.text}>Address : </Text>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}> </Text>
                                </View>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}>Tel :</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderTop: 0 }]}>
                    <View style={[styles.table, { width: '15%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.7 Country of origin</Text>
                                <Text style={styles.text}>Indonesia</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '10%', borderTop: 0, borderRight: 0 }]}>
                        <View style={[styles.tableRow, { borderBottom: 0 }]}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>ISO Code</Text>
                                <Text style={styles.text}>ID</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '15%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.8 Region of origin</Text>
                                <Text style={styles.text}>{upt !== null ? <PropinsiEn id={upt.kdProp} /> : '-'}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '10%', borderTop: 0, borderRight: 0 }]}>
                        <View style={[styles.tableRow, { borderBottom: 0 }]}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>ISO Code</Text>
                                <Text style={styles.text}>{upt !== null ? upt.kdProp : '-'}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '15%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.9 Country of destination</Text>
                                <Text style={styles.text}>{negaraTujuan !== null ? negaraTujuan.uraianNegara : '-'}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '10%', borderTop: 0, borderRight: 0 }]}>
                        <View style={[styles.tableRow, { borderBottom: 0 }]}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>ISO Code</Text>
                                <Text style={styles.text}>{datappm !== null ? datappm.negaraPartner : '-'}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '15%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.10 Region of destination</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '10%', borderTop: 0, borderRight: 1 }]}>
                        <View style={[styles.tableRow, { borderBottom: 0 }]}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>ISO Code</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderTop: 0 }]}>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 0, paddingBottom: 100 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.11 Place of dispatch</Text>
                                <Text style={styles.text}>Name : {pelMuat !== null ? pelMuat.uraianPelabuhan : '-'}</Text>
                                <Text style={styles.text}>Approval number: {ppmMutu !== null ? ppmMutu.upiRegNo : '-'}</Text>
                                <Text style={styles.text}>Address : </Text>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}></Text>
                                </View>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}>Tel : </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 1, paddingBottom: 100 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.12 Place of destination</Text>
                                <Text style={styles.text}>Name : {pelBongkar !== null ? pelBongkar.uraianPelabuhan : '-'}</Text>
                                <Text style={styles.text}>Address : </Text>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}></Text>
                                </View>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}>Tel : </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderTop: 0 }]}>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.13 Place of loading</Text>
                                <Text style={styles.text}>{pelMuat !== null ? pelMuat.uraianPelabuhan : '-'}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 1 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.14 Date of departure</Text>
                                <Text style={styles.text}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglBerangkat) : ''}</Text>
                            </View>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>Time of departure</Text>
                                <Text style={styles.text}></Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderTop: 0 }]}>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <Text style={[styles.textBold, { padding: 3 }]}>I.15 Means of transport</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                {/* <View style={styles.squareStyle}></View>
                                 */}
                                {
                                    datappm !== null && datappm.moda === '3' ?
                                        <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                        <Image src={imgCheckBox} style={styles.checkicon} />
                                }
                                <Text style={styles.text}> Aeroplane</Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                {/* <View style={styles.squareStyle}></View> */}
                                {
                                    datappm !== null && datappm.moda === '1' ?
                                        <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                        <Image src={imgCheckBox} style={styles.checkicon} />
                                }
                                <Text style={styles.text}> Vessel</Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                {/* <View style={styles.squareStyle}></View> */}
                                <Image src={imgCheckBox} style={styles.checkicon} />
                                <Text style={styles.text}> Railway</Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                {/* <View style={styles.squareStyle}></View> */}
                                <Image src={imgCheckBox} style={styles.checkicon} />
                                <Text style={styles.text}> Road Vehicle</Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRow}>
                                {/* <View style={styles.squareStyle}></View> */}
                                <Image src={imgCheckBox} style={styles.checkicon} />
                                <Text style={styles.text}> Other</Text>
                            </View>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.text}>Identification :</Text>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 1 }]}>
                        <View style={[styles.tableRow, { borderBottom: 1, paddingBottom: 30 }]}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.16 Entry BCP</Text>
                                <Text style={styles.text}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.17 Accompanying documents</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { border: 0, paddingTop: 40 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableColIsi, { width: '50%' }]}>
                            <Text style={styles.textBold}>Version 1.1 Aug 23</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '50%' }]}>
                            <Text style={styles.textBold}>1/4</Text>
                        </View>
                    </View>
                </View>
            </Page>
            <Page size="A4" style={styles.page1} wrap={false}>
                <View style={[styles.tableRow, { borderTop: 0, paddingBottom: 20 }]}>
                    <View style={[styles.table, { width: '35%', border: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>Fishery product</Text>
                                <Text style={styles.textBold}>GBHC401</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '35%', borderTop: 1, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>II.a Certificate reference no.</Text>
                                <Text style={styles.textBold}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '35%', borderTop: 1 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>II.b</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderTop: 1 }]}>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.18 Transport condition : </Text>
                                <View style={styles.tableColIsi}>
                                    <View style={styles.tableRow}>
                                        {/* <View style={styles.squareStyle}></View> */}
                                        {
                                            ppmMutu !== null && ppmMutu.mutuTempTipe === '1' ?
                                                <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                                <Image src={imgCheckBox} style={styles.checkicon} />
                                        }
                                        <Text style={styles.text}> Ambient</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColIsi}>
                                    <View style={styles.tableRow}>
                                        {/* <View style={styles.squareStyle}></View> */}
                                        {
                                            ppmMutu !== null && ppmMutu.mutuTempTipe === '2' ?
                                                <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                                <Image src={imgCheckBox} style={styles.checkicon} />
                                        }
                                        <Text style={styles.text}> Chilled</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColIsi}>
                                    <View style={styles.tableRow}>
                                        {/* <View style={styles.squareStyle}></View> */}
                                        {
                                            ppmMutu !== null && ppmMutu.mutuTempTipe === '3' ?
                                                <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                                <Image src={imgCheckBox} style={styles.checkicon} />
                                        }
                                        <Text style={styles.text}> Frozen</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 1 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.19 Container No/ Seal No</Text>
                                <View style={styles.tableColIsi}>
                                    <Text style={styles.text}>
                                        {
                                            ppmKontainer !== undefined && ppmKontainer !== null &&
                                            ppmKontainer.map((kont, index) => {
                                                return (
                                                    <>
                                                        {kont.nomor} [ {kont.nomorSegel} ]{index < ppmKontainer.length - 1 ? '; ' : ''}
                                                    </>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { borderTop: 0 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderBottom: 0 }]}>
                            <Text style={styles.textBold}>I.20 Goods certified as</Text>
                            <View style={styles.tableColIsi}>
                                <View style={styles.tableRow}>
                                    {/* <View style={styles.squareStyle}></View> */}
                                    <Image src={imgCheckBox} style={styles.checkicon} />
                                    <Text style={styles.text}>Canning industry</Text>
                                </View>
                            </View>
                            <View style={styles.tableColIsi}>
                                <View style={styles.tableRow}>
                                    {/* <View style={styles.squareStyle}></View> */}
                                    <Image src={imgCheckBoxIcon} style={styles.checkicon} /> :
                                    <Text style={styles.text}>Human consumption</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRowPart, { borderTop: 0 }]}>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 0, paddingBottom: 20 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.21 Not in use</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '50%', borderTop: 0, borderRight: 1, paddingBottom: 20 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.22 Not in use</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderTop: 0 }]}>
                    <View style={[styles.table, { width: '25%', borderTop: 0, borderRight: 0, paddingBottom: 20 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.23 Total number of packages</Text>
                                <Text style={styles.text}>
                                    {
                                        ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                            return (
                                                <>{kms.jumlah} <Kemasan id={kms.kodeKemasan} />{idx < ppmKemasan.length - 1 ? '; ' : ''}</>
                                            )
                                        })
                                    }
                                </Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '25%', borderTop: 0, borderRight: 0, paddingBottom: 20 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>I.24 Quantity Total number</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '25%', borderTop: 0, borderRight: 0, paddingBottom: 20 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>Total net weight (kg)</Text>
                                <Text style={styles.text}>{dataHc !== null ? dataHc.netto : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '25%', borderTop: 0, borderRight: 1, paddingBottom: 20 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>Total gross weight (kg)</Text>
                                <Text style={styles.text}>{dataHc !== null ? dataHc.bruto : ''}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { borderTop: 0, borderBottom: 0 }]}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textBold}>I.25 Identification of commodities</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderTop: 0 }]}>
                    <View style={[styles.table, { width: '25%', borderTop: 0, borderRight: 0, paddingBottom: 20 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>No</Text>
                                <Text style={styles.text}>{ppmMutu !== null ? ppmMutu.upiRegNo : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '75%', borderTop: 0, borderRight: 1, paddingBottom: 20 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>Code and CN title</Text>
                                <Text style={styles.text}>{dataHc !== null ? dataHc.deskripsiProduk : ''}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.tableRow, { borderTop: 0 }]}>
                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={[styles.textBoldIsi]}>Species (scientific name)</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={[styles.textBoldIsi]}>Nature of commodity</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '12%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={[styles.textBoldIsi]}>Treatment type</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={[styles.textBoldIsi]}>Vessel/ Manufacturing plant</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '8%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={[styles.textBoldIsi]}>Cold store</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '12%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={[styles.textBoldIsi]}>Number of packages</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '8%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={[styles.textBoldIsi]}>Net weight</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '10%', borderTop: 0, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={[styles.textBoldIsi]}>Batch No</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 1 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={[styles.textBoldIsi]}>Type of packaging</Text>
                            </View>
                        </View>
                    </View>
                </View>
                {
                    ppmDetil.map((detil, index) => {
                        return (
                            <>
                                <View style={[styles.tableRow, { borderTop: 0 }]}>
                                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 0 }]}>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableColIsi}>
                                                <Text style={styles.textIsi}>{detil.namaLatin}</Text>
                                            </View>
                                        </View>
                                    </View>
                                    {
                                        index === 0 ?
                                            (
                                                <>
                                                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                                <Text style={styles.textIsi}>{ppmMutuArea !== null && ppmMutuArea !== undefined && ppmMutuArea[0].mutuArea === '2' ? 'Wild' : 'Farm'}</Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.table, { width: '12%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                                <Text style={styles.textIsi}>{ppmMutu !== null ? (ppmMutu.mutuTempTipe ? <TipeTemp id={ppmMutu.mutuTempTipe} /> : '') : ''}</Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                                <Text style={styles.textIsi}>{ppmMutu !== null ? ppmMutu.upiNama : ''}</Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.table, { width: '8%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                                <Text style={styles.textIsi}></Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.table, { width: '12%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                                {
                                                                    ppmKemasan.map((kms, idxKms) => {
                                                                        return (
                                                                            <>
                                                                                <Text style={styles.textIsi}>{kms.jumlah} {<Kemasan id={kms.kodeKemasan} />}</Text>
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </View>
                                                        </View>
                                                    </View>
                                                </>
                                            ) :
                                            (
                                                <>
                                                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}></View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.table, { width: '12%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.table, { width: '8%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.table, { width: '12%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                            </View>
                                                        </View>
                                                    </View>
                                                </>
                                            )
                                    }
                                    <View style={[styles.table, { width: '8%', borderTop: 0, borderRight: 0 }]}>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableColIsi}>
                                                <Text style={styles.textIsi}>{detil.jumlah}</Text>
                                            </View>
                                        </View>
                                    </View>
                                    {
                                        index === 0 ?
                                            (
                                                <>
                                                    <View style={[styles.table, { width: '10%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                                {
                                                                    ppmMutuProd.map((mutuProd, index) => {
                                                                        return (
                                                                            <Text style={styles.textIsi}>
                                                                                {mutuProd.mutuProdNo}
                                                                            </Text>
                                                                        )
                                                                    })
                                                                }

                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 1 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                                {
                                                                    ppmKemasan.map((kms, idxKms) => {
                                                                        return (
                                                                            <>
                                                                                <Text style={styles.textIsi}>{<Kemasan id={kms.kodeKemasan} />}</Text>
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </View>
                                                        </View>
                                                    </View>
                                                </>
                                            ) :
                                            (
                                                <>
                                                    <View style={[styles.table, { width: '10%', borderTop: 0, borderRight: 0 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                                <Text style={styles.textIsi}></Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.table, { width: '13%', borderTop: 0, borderRight: 1 }]}>
                                                        <View style={styles.tableRow}>
                                                            <View style={styles.tableColIsi}>
                                                                <Text style={styles.textIsi}></Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                </>
                                            )
                                    }
                                </View>
                            </>
                        )
                    })
                }
                <View style={[styles.table, { borderTop: 0, borderBottom: 1 }]}>
                    <View style={styles.tableCol}>
                        <View style={styles.tableRow}>
                            <View style={styles.squareStyle}></View>
                            <Text style={styles.text}> Final Consumer</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 10, border: 0 }]}>
                    <View style={styles.tableRowPart}>
                        <View style={[styles.tableColPart, { borderBottom: 0, backgroundColor: "#000000" }]}>
                            <Text style={[styles.textBold, { color: "#ffffff" }]}>Part II. Certfication</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 10, borderTop: 0 }]}>
                    <View style={styles.tableRowPart}>
                        <View style={[styles.tableColPart, { borderBottom: 0 }]}>
                            <Text style={styles.textBold}>Animal Health</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 10, borderTop: 0 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { borderBottom: 0 }]}>
                            <Text style={styles.textBold}>(*)Animal health attestations for fish and crustaceans of aquaculture origin</Text>
                            <Text style={styles.text}>I, the undersigned official Certifying Officer, hereby certify that the aquaculture animals or products thereof referred to in Part I of this certificate:</Text>
                            <Text style={styles.textBold}>(*)[AH/T153 Territory requirements</Text>
                            <Text style={styles.text}>originate from a country, territory, zone or compartment declared free from [Epizootic Haematopoietic Necrosis] [Taura syndrome] [Yellowhead disease] and comply with the relevant GB requirements;]</Text>
                            <Text style={styles.textBold}>(*)[AH/T154 Territory requirements</Text>
                            <Text style={styles.text}>originate from a country, territory, zone or compartment declared free from [Viral Haemorrhagic Septicaemia] [Infectious Haematopoietic Necrosis] " [Infectious Salmon Anaemia (genotype HPR- deleted)] [Koi Herpes Virus] [White spot disease] and comply with the relevant GB requirements;]</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { border: 0, paddingTop: 40 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableColIsi, { width: '50%' }]}>
                            <Text style={styles.textBold}>Version 1.1 Aug 23</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '50%' }]}>
                            <Text style={styles.textBold}>2/4</Text>
                        </View>
                    </View>
                </View>
            </Page>
            <Page size="A4" style={styles.page1} wrap={false}>
                <View style={[styles.tableRow, { borderTop: 0, paddingBottom: 20 }]}>
                    <View style={[styles.table, { width: '35%', border: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>Fishery product</Text>
                                <Text style={styles.textBold}>GBHC401</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '35%', borderTop: 1, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>II.a Certificate reference no.</Text>
                                <Text style={styles.textBold}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '35%', borderTop: 1 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>II.b</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 10, border: 0, width: "95%" }]}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textBold}>(*)[AH/T155 Territory requirements</Text>
                            <View style={[styles.tableRow, { paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.textBold}>(*)EITHER</Text>
                                <Text style={[styles.text, { paddingLeft: 14 }]}>[come from a country, territory, zone or compartment:</Text>
                            </View>
                            <View style={[styles.tableColPart, { width: "100%", border: 0, paddingLeft: 40 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textBold}>(a)</Text>
                                    <Text style={[styles.text, { paddingLeft: 3, textAlign: 'justify' }]}>where [Spring Viraemia of Carp (SVC)] [Gyrodactylus salaris (GS)] [Bacterial Kidney Disease (BKD)] is (are) notifiable to the competent authority and reports of suspicion of infection of the relevant disease(s) must be immediately investigated by the competent authority;</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textBold}>(b)</Text>
                                    <Text style={[styles.text, { paddingLeft: 3, textAlign: 'justify' }]}>where all aquaculture animals of species susceptible to the relevant disease(s) introduced into that country, territory, zone or compartment originate from a source free of the relevant diseases;</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textBold}>(c)</Text>
                                    <Text style={[styles.text, { paddingLeft: 3, textAlign: 'justify' }]}>where species susceptible to the relevant disease(s) are not vaccinated against the relevant disease(s); and</Text>
                                </View>
                                <View style={[styles.tableRow, { width: "90%" }]}>
                                    <Text style={styles.textBold}>(d)</Text>
                                    <Text style={[styles.textBold, { paddingLeft: 7 }]}>(*)EITHER</Text>
                                    <Text style={[styles.text, { paddingLeft: 15, textAlign: 'justify' }]}>(*)[in the case of BKD, complies with requirements for disease freedom equivalent to those laid down in Decision 2009/177;]</Text>
                                </View>
                                <View style={[styles.tableRow, { width: "90%" }]}>
                                    <Text style={[styles.textBold, { paddingLeft: 7 }]}></Text>
                                    <Text style={[styles.textBold, { paddingLeft: 9 }]}>(*)AND/OR</Text>
                                    <Text style={[styles.text, { paddingLeft: 15, textAlign: 'justify' }]}>[in the case of [SVC] [GS], complies with requirements for disease freedom laid down in the relevant WOAH Standard;]</Text>
                                </View>
                                <View style={[styles.tableRow, { width: "90%" }]}>
                                    <Text style={[styles.textBold, { paddingLeft: 7 }]}></Text>
                                    <Text style={[styles.textBold, { paddingLeft: 9 }]}>(*)AND/OR</Text>
                                    <Text style={[styles.text, { paddingLeft: 15, textAlign: 'justify' }]}>has been emptied, cleansed and disinfected, and fallowed for at least 6 weeks;</Text>
                                </View>
                                <View style={[styles.tableRow, { width: "90%" }]}>
                                    <Text style={[styles.textBold, { paddingLeft: 51 }]}>(i)</Text>
                                    <Text style={[styles.text, { paddingLeft: 5 }]}>has been emptied, cleansed and disinfected, and fallowed for at least 6 weeks;</Text>
                                </View>
                                <View style={[styles.tableRow, { width: "90%" }]}>
                                    <Text style={[styles.textBold, { paddingLeft: 51 }]}>(ii)</Text>
                                    <Text style={[styles.text, { paddingLeft: 13 }]}>has been restocked with animals from areas certified free from the relevant disease by the competent authority;]]</Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 10, paddingLeft: 8, border: 0, width: "95%" }]}>
                                <Text style={styles.textBold}>(*)AND/OR</Text>
                                <Text style={[styles.text, { paddingLeft: 14 }]}>[in the case consignments for which GS requirements apply, have been held, immediately prior to export, in water with a salinity of at least 25 parts per thousand for a continuous period of at least 14 days and no other live aquatic animals of the species susceptible to GS have been introduced during that period;]</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 10, paddingLeft: 8, border: 0, width: "95%" }]}>
                                <Text style={styles.textBold}>(*)AND/OR</Text>
                                <Text style={[styles.text, { paddingLeft: 14 }]}>[in the case of eyed fish eggs for which GS requirements apply, have been disinfected by a method demonstrated to be effective against GS;]]</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={styles.textBold}>(*)AH/P502 Transport and labelling requirements</Text>
                            <View style={[styles.tableRow, { paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.textBold}>(a)</Text>
                                <Text style={[styles.text, { paddingLeft: 14 }]}>the aquaculture animals referred to in Part I of this certificate are placed under conditions, including water quality, that do not alter their health status; and</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.textBold}>(b)</Text>
                                <Text style={[styles.text, { paddingLeft: 14 }]}>prior to loading the transport container or well boat is clean and disinfected or previously unused; and</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.textBold}>(c)</Text>
                                <Text style={[styles.text, { paddingLeft: 14 }]}>the consignment is identified in accordance with GB requirements.</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <View style={styles.tableRowPart}>
                                <Text style={styles.textBold}>Public Health</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 10, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.text}>I, the undersigned official inspector, declare that I am aware of the relevant requirements of the GB Regulations, and certify that the fishery products described in Part I of this certificate were produced in accordance with those requirements, in particular that:</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 10, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.textBold}>PH/E100A Establishment requirements</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 5, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.text}>the establishment(s) where the product(s) come(s) from operate(s) under the HACCP principles in accordance with GB regulations;</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 10, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.textBold}>PH/P114 Production requirements</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 5, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.text}>comply with health standards and the requirements for catching and handling on board vessels, landing, handling and where appropriate preparing, processing, freezing and hygienic thawing as required by GB regulations;</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 10, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.textBold}>PH/1005 Inspection requirements</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 5, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.text}>have satisfactorily undergone the relevant official controls laid down by GB regulations;</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { border: 0, paddingTop: 40 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableColIsi, { width: '50%' }]}>
                            <Text style={styles.textBold}>Version 1.1 Aug 23</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '50%' }]}>
                            <Text style={styles.textBold}>3/4</Text>
                        </View>
                    </View>
                </View>
            </Page>
            <Page size="A4" style={styles.page1} wrap={false}>
                <View style={[styles.tableRow, { borderTop: 0, paddingBottom: 20 }]}>
                    <View style={[styles.table, { width: '35%', border: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>Fishery product</Text>
                                <Text style={styles.textBold}>GBHC401</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '35%', borderTop: 1, borderRight: 0 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>II.a Certificate reference no.</Text>
                                <Text style={styles.textBold}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { width: '35%', borderTop: 1 }]}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColIsi}>
                                <Text style={styles.textBold}>II.b</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { border: 0, width: "95%" }]}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <View style={[styles.tableRow, { paddingTop: 10, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.textBold}>PH/MK001 Marking requirements</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 5, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.text}>the product(s) described in Part I of this certificate has (have) been marked in compliance with the relevant GB regulations;</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 10, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.textBold}>PH/RP002 Residue plans</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 5, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.text}>if of aquaculture origin, the guarantees provided by the residue monitoring plans submitted to GB by the country of origin are fulfilled in accordance with GB regulations;</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 10, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.textBold}>PH/S105B Storage and transportation requirements</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 5, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.text}>have been wrapped, packaged, stored and transported in compliance with relevant GB regulations;</Text>
                            </View>
                            <View style={[styles.tableRow, { paddingTop: 5, paddingLeft: 8, border: 0 }]}>
                                <Text style={styles.text}>(*) Keep as appropriate.</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                        <View style={[styles.tableRow, { backgroundColor: "#000000" }]}>
                            <Text style={[styles.textBold, { color: "#ffffff" }]}>Certifying Officer</Text>
                        </View>
                        <View style={[styles.tableCol, { borderRight: 1, borderLeft: 1 }]}>
                            <Text style={[styles.textBold, { textAlign: "left" }]}>By signing this certificate, I certify that the requirements laid out above and in the accompanying notes for completion have been met.</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableColIsi, { borderLeft: 1, paddingBottom: 50, width: '50%' }]}>
                                <Text style={styles.text}>Name (in capital letters):</Text>
                                <Text style={styles.text}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                            </View>
                            <View style={[styles.tableColIsi, { borderRight: 1, paddingBottom: 50, width: '50%' }]}>
                                <Text style={styles.text}>Qualification and title:</Text>
                                <Text style={styles.text}>OFFICIAL INSPECTOR</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableColIsi, { borderLeft: 1, paddingBottom: 50, width: '50%' }]}>
                                <Text style={styles.text}>Date: {dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                            </View>
                            <View style={[styles.tableColIsi, { borderRight: 1, paddingBottom: 50, width: '50%' }]}>
                                <Text style={styles.text}>Signature:</Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow, { borderRight: 1, paddingLeft: 3, paddingBottom: 50, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={styles.text}>Stamp:</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { border: 0, paddingTop: 240 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableColIsi, { width: '50%' }]}>
                            <Text style={styles.textBold}>Version 1.1 Aug 23</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '50%' }]}>
                            <Text style={styles.textBold}>4/4</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default DraftUK